import RepositoryBase from "./repositoryBase";
import type EventBus from "services/eventBus";
import type { IPagedResults, IPagination } from "data/types";
import type BackOfficeConnector from "data/backOfficeConnector";
import type { AxiosResponse } from "axios";
import LustrationReportRequestCreateResponse from "entities/lustrationReportRequestCreateResponse";
import { serializeFilters } from "utils/filters";
import type LustrationReportCreateRequest from "../entities/lustrationReportCreateRequest";
import LustrationReportsSearchRequest from "entities/lustrationReportsSearchRequest";

export default class LustrationRepository extends RepositoryBase<BackOfficeConnector> {
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  getAll(
    filters: LustrationReportsSearchRequest,
    pagination: IPagination,
    abortSignal: AbortSignal
  ): Promise<IPagedResults<LustrationReportsSearchRequest>> {
    return this.callApi(api =>
      api
        .all("enforcement")
        .all("lustration_report_search")
        .postPagedEntities({ ...serializeFilters(filters, false), ...pagination }, LustrationReportsSearchRequest, abortSignal)
    );
  }

  create(request: LustrationReportCreateRequest) {
    return this.callApi(api =>
      api.all("enforcement").all("lustration_reports").postEntity(request, LustrationReportRequestCreateResponse)
    );
  }

  async downloadReport(id: string): Promise<AxiosResponse<File>> {
    return this.callApi(api => api.all("enforcement").one("lustration_reports", id).all("report").getRaw() as any);
  }
}
